import styled from "styled-components";

const Small = styled.small `
  font-size: 0.90em;
`;

export default Small;
